import React from "react";
import Card from "../Card/Card";
import Popup from "../Popup/Popup";
import "./Project.scss";

export default class Project extends React.Component {
  state = {
    popup: false,
    card: {},
  };

  clickHandler = (title, description, tools, img, hasLink, link) => {
    this.setState({
      popup: !this.state.popup,
      card: {
        title: title,
        description: description,
        tools:tools,
        img: img,
        hasLink: hasLink,
        link: link
      },
    });
  };

  render() {
    const { popup, card } = this.state;
    return (
      <div className="project" id="project">
        <Popup popup={popup} card={card} clickHandler={this.clickHandler} />
        <h2 className="project__header">Projects</h2>
        <div className="project__card-container">
          <Card clickHandler={this.clickHandler} />
        </div>
      </div>
    );
  }
  F;
}
